export default "__VITE_ASSET__025ab660__"